import React from 'react';

interface PageHeaderProps {
  title: string;
  description?: string;
  icon?: React.ReactNode;
  action?: React.ReactNode;
  className?: string;
}

/**
 * 공통 페이지 헤더
 * 페이지 제목, 설명, 아이콘, 액션 버튼을 통일된 스타일로 제공합니다.
 * 
 * @example
 * <PageHeader 
 *   title="내 정보 수정" 
 *   description="회원 정보를 관리합니다"
 *   icon={<User className="w-6 h-6" />}
 * />
 */
export const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  description,
  icon,
  action,
  className = '',
}) => {
  return (
    <div className={`flex flex-col sm:flex-row sm:items-center justify-between gap-3 sm:gap-4 ${className}`.trim()}>
      <div className="min-w-0">
        <h1 className="text-2xl md:text-3xl font-bold flex items-center gap-3">
          {icon && <span className="text-primary">{icon}</span>}
          {title}
        </h1>
        {description && (
          <p className="text-gray-600 mt-2 text-sm md:text-base">
            {description}
          </p>
        )}
      </div>
      {action && (
        <div className="flex-shrink-0">
          {action}
        </div>
      )}
    </div>
  );
};
